import React, { FC } from "react";
import { DRList } from "./list/DRList";
import { lddGlobalSessionInfo } from "../../Components/navigationTypes";
import { useAppSelector } from "../../redux/hooks";
import { launchLDDzoho } from "./drFuncs";
import { FileTabButton } from "../../SideDrawer/fileTabButton";
import { fileTabVal } from "../../SideDrawer/sideTypes";
import { adMapper } from "../../util/rpwConst";
import "../../Components/Home/FileListPage.css";

const DRListContainer: FC = ({ }) => {
    const sessionInfo: lddGlobalSessionInfo = useAppSelector((state) => state.SessionInfo);
    return (
        <div className="dashboardContainer h-100">
            <div className="dashNavContainer">
                <FileTabButton
                    setValue={fileTabVal.EMPTY}
                    setMenuState={() => null}
                    stateValue={fileTabVal.EMPTY}
                    icon={"fa-duotone fa-solid fa-file"}
                    title={"Files"}
                />
                <FileTabButton
                    setValue={fileTabVal.EMPTY}
                    setMenuState={() => null}
                    stateValue={null}
                    icon={"fa-duotone fa-solid fa-file"}
                    title={"OREA"}
                    external={{ 
                        newTab: true , 
                        url: `../docservice/?SessionID=${sessionInfo.sid}`, 
                        adImage: "../docservice/logo-orea.png"}
                    }
                />
            </div>

            <div className="dashboard m-0 w-100">
                <DRList />
            </div>
        </div>
    )
}

export default DRListContainer;